import { href, type Route } from '../app/useHashRoute.js';
import { LegalLinks } from '../legal/LegalLinks.js';

const items: { route: Route; title: string; blurb: string; icon: string }[] = [
  {
    route: 'play',
    title: 'Play',
    blurb: 'Matchmaking, or a private table of 4, 6 or 8',
    icon: '🚨',
  },
  {
    route: 'tutorial',
    title: 'Tutorial',
    blurb: 'How to play, and how to save your wins',
    icon: '📖',
  },
  { route: 'cast', title: 'The cast', blurb: 'Every character, every face', icon: '🎭' },
  {
    route: 'settings',
    title: 'Settings',
    blurb: 'This browser, sound and motion, About',
    icon: '⚙',
  },
];

export function MenuScreen() {
  return (
    <div className="page stack">
      <h1 className="screen-title">Situation Room</h1>
      <p className="muted-on-dark">
        Start or join a match, learn how to play, meet the cast, or change your settings.
      </p>
      <ul className="menu-grid" role="list">
        {items.map((item) => (
          <li key={item.route}>
            <a className="menu-tile" href={href(item.route)}>
              <span className="menu-tile__icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="menu-tile__title">{item.title}</span>
              <span className="menu-tile__blurb">{item.blurb}</span>
            </a>
          </li>
        ))}
      </ul>
      <LegalLinks />
    </div>
  );
}
